module.exports = __webpack_public_path__ + "images/ag-placeholder-animal-welfare.svg";